import { render, staticRenderFns } from "./Landing2Hero.vue?vue&type=template&id=36ae32a5&scoped=true"
import script from "./Landing2Hero.vue?vue&type=script&lang=js"
export * from "./Landing2Hero.vue?vue&type=script&lang=js"
import style0 from "./Landing2Hero.vue?vue&type=style&index=0&id=36ae32a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae32a5",
  null
  
)

export default component.exports